const isCordovaApp = window.cordova != null
const isBrowserApp = !isCordovaApp

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList

const result = {text: null, isFinal: null}

import CordovaSpeechRecognition from './cordova-speech-to-text-adapter'

export default {

    props: {
        value: {type: Object, required: true},
        language: {type: String, required: true},
        grammars: {type: Array},
        interimResults: {type: Boolean, default: true},
        maxAlternatives: {type: Number, default: 1},
    },

    data() {
        return {
            isListening: false,
            speechStarted: false,
            isAvailable: false,
            showModal: false,
        }
    },

    computed: {
        classes() {
            let base = 'speech-to-text'
            return {
                'speech-to-text': true,
                'speech-to-text--is-listening': this.isListening,
                'speech-to-text--speech-started': this.speechStarted,
            }
        }
    },

    watch: {
        grammars: 'setGrammers',
        language: 'setLanguage',
        interimResults: 'setInterimResults',
        maxAlternatives: 'setMaxAlternatives',

        isAvailable() {
            this.$emit('is-available', this.isAvailable)
        }
    },

    created() {
        if (isBrowserApp) {

            if (!SpeechRecognition) return this.onerror('unavailable')

            this.recognition = new SpeechRecognition()
            this.recognition.onstart = this.onstart
            this.recognition.onspeechstart = this.onspeechstart
            this.recognition.onresult = this.onresult
            this.recognition.onspeechend = this.onspeechend
            this.recognition.onerror = this.onerror
            this.recognition.onend = this.onend
            // We don't use auto-executing immediate watchers because they will fire even in the Cordova context
            this.setGrammers()
            this.setLanguage()
            this.setInterimResults()
            this.setMaxAlternatives()
            this.isAvailable = true
        } else if (isCordovaApp) {
            CordovaSpeechRecognition.isRecognitionAvailable()
                .then(available => {
                    this.isAvailable = available && process.env.VUE_APP_CONTEXT != 'HUAWEI_ANDROID' // force unavailable for Huawei app
                    if (this.isAvailable == false) new Error('unavailable')
                })
                .catch(error => this.onerror(error))
        }
    },

    methods: {
        setGrammers() {
            if (isBrowserApp) {
                if (!this.grammars) return
                let grammar = '#JSGF V1.0 grammar phrases public <phrase> = ' + this.grammars.join(' | ') + ' '
                let speechRecognitionList = new SpeechGrammarList()
                speechRecognitionList.addFromString(grammar, 1)

                this.recognition.grammars = speechRecognitionList
            }
        },

        setLanguage() {
            if (isBrowserApp) {
                this.recognition.lang = this.language
            }
        },

        setInterimResults() {
            if (isBrowserApp) {
                this.recognition.interimResults = this.interimResults
            }
        },

        setMaxAlternatives() {
            if (isBrowserApp) {
                this.recognition.maxAlternatives = this.maxAlternatives
            }
        },

        onresult(event) {

            var speechResult = event.results[0]

            result.text = speechResult[0].transcript
            result.isFinal = speechResult.isFinal

            if (result.isFinal) {
                if (result.text.toLowerCase().includes("it's got that")) {
                    result.text = "It's got that Vusa"
                } else if (result.text.toLowerCase().endsWith("flavour")) {
                    result.text = "It's got that Vusa"
                }else if (result.text.toLowerCase().endsWith("flavour.")) {
                    result.text = "It's got that Vusa"
                }
            }

            this.$emit('input', result)
        },

        onstart(event) {
            this.isListening = true
        },

        onspeechstart(event) {
            this.speechStarted = true
        },

        onspeechend(event) {
            this.recognition.stop()
            this.speechStarted = false
        },

        onend(event) {
            this.isListening = false
        },

        onerror(event) {
            let error = event.error || event
            this.isListening = false
            this.speechStarted = false
            this.showModal = false

            switch (error) {
                case 'aborted':
                    break; // We can treat this as "speech end"?
                case 'unavailable':
                    this.isAvailable = false;
                    this.$emit('error', error);
                    break;
                case 'no-speech':
                case 'network':
                case 'audio-capture':
                case 'not-allowed':
                    this.$emit('error', error);
                    break;
            }
        },

        start() {

            if (this.isListening) return this.stop()

            if (isBrowserApp) {
                this.recognition.start()
            } else {
                CordovaSpeechRecognition.isRecognitionAvailable()
                    .then(available => available ? CordovaSpeechRecognition.hasPermission() : new Error('unavailable'))
                    .catch(error => this.onerror(error))
                    .then(hasPermission => {
                        let permissionPromise = hasPermission ? Promise.resolve() : CordovaSpeechRecognition.requestPermission()
                        permissionPromise
                            .then(permission => {

                                this.showModal = true
                                this.isListening = true
                                this.speechStarted = true
                                CordovaSpeechRecognition.start(
                                    data => {
                                        result.text = data[0]

                                            if (result.text.toLowerCase().includes("it's got that")) {
                                                result.text = "It's got that Vusa"
                                            } else if (result.text.toLowerCase().endsWith("flavour")) {
                                                result.text = "It's got that Vusa"
                                            }else if (result.text.toLowerCase().endsWith("flavour.")) {
                                                result.text = "It's got that Vusa"
                                            }

                                        this.$emit('input', result)
                                    },
                                    error => onerror,
                                    {language: this.language, showPopup: false, showPartial: true}
                                )
                            })
                            .catch(error => this.onerror('not-allowed'))
                    })
            }
        },

        stop() {
            this.isListening = false
            this.speechStarted = false
            this.showModal = false

            if (!this.isAvailable) return

            if (isBrowserApp) {
                this.recognition.stop()
            } else {
                CordovaSpeechRecognition.stop()
            }
        },
    },

    beforeDestroy() {
        this.stop()

        if (this.recognition) {
            this.recognition.onstart = this.recognition.onspeechstart = this.recognition.onresult = this.recognition.onspeechend = this.recognition.onend = this.recognition.onerror = null
        }
    },
}